import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import actionsApp from '~/redux/app/actions';
import actionsCookie from '~/redux/cookie/actions';
import Dialog from '@mui/material/Dialog';
import Text from '~/src/components/Typography/Text';
import nl2br from 'react-nl2br';
import formatText from '~/src/lib/formatText';
import List from '@mui/material/List';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import messageService from '~/src/lib/req/message';
import Switch from '@mui/material/Switch';
import { useScreenDetector } from '~/src/hooks/useScreenDetector';
import getCustomButton1 from '~/src/lib/getCustomButton1';
import getCustomRadius from '~/src/lib/getCustomRadius';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import translateMsg from '~/src/lib/translateMsg';
import setCookie from '~/src/lib/setCookie';
import getCookie from '~/src/lib/getCookie';

function App(props) {
    const [view, setView] = React.useState('main');
    const [datas, setDatas] = React.useState([]);
    const [expanded, setExpanded] = React.useState(false);

    const business = useSelector((state) => state.business);
    const lang = useSelector((state) => state.lang);

    const cookieConsent = useSelector((state) => state.cookie);

    const cookieModal = useSelector((state) => state.app.cookieModal);

    const { isMobile, isTablet, isDesktop } = useScreenDetector();

    const dispatch = useDispatch();

    const router = useRouter();

    return false;

    /*

  if (!business) {
    return false;
  }
  if (Object.keys(business).length === 0) {
    return false;
  }

  const handleOpen = () => {
    dispatch(actionsApp.setCookieModal(true));
  };

  const handleClose = () => {
    dispatch(actionsApp.setCookieModal(false));
  };

  useEffect(() => {
    if (typeof getCookie("cookieConsent") === "object") {
      dispatch(actionsApp.setCookieModal(true));
    }
    fetchData();
  }, []);

  const fetchData = async () => {
    const result = await messageService.get(
      `/cookie/${business.info.uuid}/list`
    );
    setDatas(result.data);
  };



  const setCookieConsent = () => {
    setCookie("cookieConsent", "on", 1);
  };

  const acceptAllCookie = () => {
    datas.map((item, index) => {
      if (item.enabled === 0) {
        return false;
      }
      if (item.mandatory === 1) {
        return false;
      }

      dispatch(
        actionsCookie.setCookieConsent({
          name: item.name,
          accept: true,
        })
      );
    });
  };

  const denyAllCookie = () => {
    //dispatch(actionsCookie.resetCookieConsent());
    datas.map((item, index) => {
      if (item.enabled === 0) {
        return false;
      }
      if (item.mandatory === 1) {
        return false;
      }

      dispatch(
        actionsCookie.setCookieConsent({
          name: item.name,
          accept: false,
        })
      );
    });
  };

  const _displayMain = () => {
    return (
      <>
        <DialogTitle id="scroll-dialog-title">
         {translateMsg('webapp', 'pwa_ui__respect_privacy')}
        </DialogTitle>
        <DialogContent dividers="paper">
          <div>
            <Text variant="body1">
              {nl2br(formatText(translateMsg('webapp', 'pwa_ui__privacy_policy')))}
            </Text>
          </div>
        </DialogContent>
        <DialogActions>
          <div
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              justifyContent: isMobile ? "inherit" : "space-around",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div>
              <div
                onClick={() => {
                  setView("detail");
                }}
                style={{
                  cursor: "pointer",
                  paddingTop: 7,
                  paddingBottom: isMobile ? 20 : 8,
                  
                }}
              >
                <Text variant="h4" color={getCustomButton1(business)}>
                {translateMsg('webapp', 'pwa_ui__configure_cookies')}
                </Text>
              </div>
            </div>

            <div
              style={{
                width: isMobile ? "100%" : "auto",
              }}
            >
              <CustomButton
                onClick={() => {
                  setCookieConsent();
                  acceptAllCookie();
                  handleClose();
                }}
                size="large"
                fullWidth
                variant="contained"
                color="primary"
                style={{
                  textTransform: "none",
                  border: "1px solid #FFFFFF",
                }}
              >
                <Text variant="h4">
                  {translateMsg('webapp', 'pwa_ui__accept')}
                </Text>
              </CustomButton>
            </div>
          </div>
        </DialogActions>
      </>
    );
  };

  const _displayArrow = (id) => {
    if (id === expanded) {
      return (
        <div
          onClick={() => {
            setExpanded(false);
          }}
          style={{
            cursor: "pointer",
          }}
        >
          <KeyboardArrowUpIcon style={{ fontSize: 30, color: "19f9f9f" }} />
        </div>
      );
    }
    return (
      <div
        onClick={() => {
          setExpanded(id);
        }}
        style={{
          cursor: "pointer",
        }}
      >
        <KeyboardArrowDownIcon
          color="#9f9f9f"
          style={{ fontSize: 30, color: "19f9f9f" }}
        />
      </div>
    );
  };

  const _displayCookiesMandatory = () => {
    const results = datas.filter((o) => o.mandatory === 1);

    if (results.length === 0) {
      return false;
    }

    return (
      <div>
        <div
          style={{
            marginTop: 10,
            marginBottom: 10,
          }}
        >
          <Text variant="h6">
          {translateMsg('webapp', 'pwa_ui__legitimate_interest_cookies')}
          </Text>
        </div>
        <div>
          {results.map((item, index) => {
            if (item.enabled === 0) {
              return false;
            }
            const match = cookieConsent.find((o) => o.name === item.name);

            if (item.title[lang] && item.description[lang]) {
              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                  key={index}
                >
                  <div
                    style={{
                      flex: 1,
                    }}
                  >
                    <div>
                      <Text variant="body1">{item.title[lang]}</Text>
                    </div>

                    {expanded === item.id ? (
                      <div>
                        {typeof item.url[lang] === "string" && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: isMobile ? "column" : "row",
                            }}
                          >
                            <Text variant="body2">
                            
                            {translateMsg('webapp', 'pwa_ui__confidentiality_policy')}{" "}
                            </Text>

                            <a target="_blank" rel="noreferrer" href={item.url[lang]}>
                              <Text variant="body2">{item.url[lang]}</Text>
                            </a>
                          </div>
                        )}
                        <Text variant="body2">{item.description[lang]}</Text>
                      </div>
                    ) : (
                      false
                    )}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Switch checked={true} style={{
                        opacity: 0.4
                    }} />
                    {_displayArrow(item.id)}
                  </div>
                </div>
              );
            }

            return false;
          })}
        </div>
      </div>
    );
  };

  const _displayCookiesOther = () => {
    const results = datas.filter((o) => o.mandatory === 0);

    if (results.length === 0) {
      return false;
    }

    return (
      <div
        style={{
          marginTop: 20,
        }}
      >
        <div>
          <Text variant="h6">
          {translateMsg('webapp', 'pwa_ui__other_cookies')}
          </Text>
        </div>
        <div>
          {results.map((item, index) => {
            if (item.enabled === 0) {
              return false;
            }
            const match = cookieConsent.find((o) => o.name === item.name);

            if (item.title[lang] && item.description[lang]) {
              return (
                <div
                key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                  key={index}
                >
                  <div
                    style={{
                      flex: 1,
                    }}
                  >
                    <div>
                      <Text variant="body1">{item.title[lang]}</Text>
                    </div>

                    {expanded === item.id ? (
                      <div>
                        {typeof item.url[lang] === "string" && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: isMobile ? "column" : "row",
                            }}
                          >
                            <Text variant="body2">
                            
                            {translateMsg('webapp', 'pwa_ui__confidentiality_policy')}{" "}
                            </Text>

                            <a target="_blank" rel="noreferrer" href={item.url[lang]}>
                              <Text variant="body2">{item.url[lang]}</Text>
                            </a>
                          </div>
                        )}
                        <Text variant="body2">{item.description[lang]}</Text>
                      </div>
                    ) : (
                      false
                    )}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Switch
                      checked={match ? (match.accept ? true : false) : true}
                      onChange={(event) => {
                        console.log(event.target.checked);
                        dispatch(
                          actionsCookie.setCookieConsent({
                            name: item.name,
                            accept: event.target.checked,
                          })
                        );
                      }}
                    />
                    {_displayArrow(item.id)}
                  </div>
                </div>
              );
            }

            return false;
          })}
        </div>
      </div>
    );
  };

  const _displayDetail = () => {
    return (
      <>
        <DialogTitle id="scroll-dialog-title">
        {translateMsg('webapp', 'pwa_ui__configure_cookies_and_consents')}
        </DialogTitle>
        <DialogContent dividers="paper">

        <Text variant="body1">
        {translateMsg('webapp', 'pwa_ui__cookies_policy')}
              </Text>
        

          <List>
            {_displayCookiesMandatory()}
            {_displayCookiesOther()}
          </List>
        </DialogContent>
        <DialogActions>
          <div
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              justifyContent: isMobile ? "inherit" : "space-around",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div
              onClick={() => {
                setView("main");
              }}
              style={{
                cursor: "pointer",
              }}
            >
              <Text variant="h4" color={getCustomButton1(business)}>
              {translateMsg('webapp', 'pwa_ui__return')}
              </Text>
            </div>

            <div
              style={{
                paddingTop: 20,
                paddingBottom: 20,
                //width: isMobile ? "100%" : "auto",
                cursor: "pointer",
              }}
              onClick={() => {
                setCookieConsent();
                denyAllCookie();
                handleClose();
              }}
            >
              <Text variant="h4" color={getCustomButton1(business)}>
              {translateMsg('webapp', 'pwa_ui__deny_everything')}
              </Text>
            </div>

            <div
              style={{
                width: isMobile ? "100%" : "auto",
              }}
            >
              <CustomButton
                onClick={() => {
                  setCookieConsent();
                  handleClose();
                }}
                size="large"
                fullWidth
                variant="contained"
                color="primary"
                style={{
                  textTransform: "none",
                  border: "1px solid #FFFFFF",
                }}
              >
                <Text variant="h4">
                {translateMsg('webapp', 'pwa_ui__save_and_exit')}

                </Text>
              </CustomButton>
            </div>
          </div>
        </DialogActions>
      </>
    );
  };


  if (typeof getCookie("cookieConsent") === "string") {
    //return false;
  }

  if(cookieModal === false) {
      return false;
  }

  return (
    <div>
      <style type="text/css">
        {`
            .yourClassName .MuiPaper-rounded {
                border-radius: ${getCustomRadius(business)}px;
            }
        `}
      </style>

      <Dialog
        fullScreen={isMobile ? true : false}
        fullWidth={isMobile ? false : true}
        maxWidth="md"
        disableBackdropClick={true}
        className="yourClassName"
        open={cookieModal}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{
          borderRadius: getCustomButton1(business),
          margin: isMobile ? 10 : 0,
        }}
      >
        {view === "detail" ? _displayDetail() : _displayMain()}
      </Dialog>
    </div>
  );
  */
}

export default App;
